import { ChainId } from '@kwikswap/reef-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS = {
  [ChainId.MAINNET]: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb',
  [ChainId.TESTNET]: '0xE06Ff67528BfCBF023AD86eD094EE04d78894FFf',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
